import { createElement, type ReactNode } from "react";

import type { PageTemplate } from "./contract.js";

/** Renders one page of a storefront template: each section with its content, then the layout. */
export function PageTemplateView<C extends { [K in keyof C]: object }>({
  template,
  content,
}: {
  template: PageTemplate<C>;
  content: C;
}) {
  const sections = {} as { [K in keyof C]: ReactNode };
  for (const key of Object.keys(template.sections) as (keyof C & string)[]) {
    // `display: contents`, so the marker the parity suite finds takes no part in the layout.
    sections[key] = (
      <div data-template-section={key} className="contents">
        {createElement(template.sections[key], content[key])}
      </div>
    );
  }
  return <template.Layout sections={sections} />;
}
